import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { Toast } from "@/utils";
import {
  getPrototypeRegistrationList,
  getSerialUsageByPrototypeRegistrationId,
} from "@/request/view/prototypeManagement";
import { useTable } from "@/views/notice/serve/table";


export default /*#__PURE__*/_defineComponent({
  __name: 'useDetailsForm',
  setup(__props, { expose: __expose }) {

const {
  requestConfig,
  table,
  requestPayload,
  initPayload,
  getListData,
  searchData,
  deleteRecords,
  hanldeUpdatePageNum,
} = useTable();

const visible = ref(false);

requestConfig.pull_fn = getSerialUsageByPrototypeRegistrationId;

const pagination = ref({
  current: 1,
  defaultPageSize: 10,
  total: 0,
  pageSizeOptions: ["10", "20", "50", "100"],
  showTotal: (total) => `共 ${total} 条`,
  showQuickJumper: true,
  showSizeChanger: true,
  onChange: (page, pageSize) => {
    changePagination(page);
  },
});
const changePagination = (page) => {
  pagination.value.current = page;
};

initPayload({
  prototypeRegistrationId: null,
});

const columns = [
  { title: "日期", dataIndex: "localDate", align: "center" },
  { title: "使用次数", dataIndex: "number", align: "center" },
];

const showModal = async (id) => {
  requestPayload.prototypeRegistrationId = id;
  await getListData();
  if (table.data.length === 0) {
    return Toast("warning", "设备无使用情况", 3);
  }
  visible.value = true;
};

__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "设备使用情况",
    footer: null,
    width: "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        "data-source": _unref(table).data,
        bordered: "",
        columns: columns,
        rowKey: "id",
        style: {"margin-top":"10px"},
        pagination: pagination.value
      }, null, 8, ["data-source", "pagination"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})